import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {
    documents: [],
  }
}

const state = getDefaultState()

const mutations = {
  SET_DOCUMENTS(state, payload) {
    state.documents = payload
  },
}

const actions = {
  async getPaginateList({ commit }, params) {
    const apiResult = await apiService.post(route('member.fcs.project-transaction-slip.get-paginate'), params)
    if (apiResult) {
      return apiResult
    }
  },

  async deleteDocument({ commit }, params) {
    const apiResult = await apiService.post(route('member.fcs.project-transaction-slip.delete'), params)
    if (apiResult) {
      return apiResult
    }
  },

  async downloadDocuments({ commit }, params) {
    const apiResult = await apiService.post(route('member.fcs.project-transaction-slip.download-documents'), params)
    if (apiResult) {
      return apiResult
    }
  },

  async storeProjectTransactionSlip({ commit }, params) {
    const apiResult = await apiService.post(route('member.fcs.project-transaction-slip.create'), params)
    if (apiResult) {
      return apiResult
    }
  },
}

export default {
  state,
  mutations,
  actions,
}
